import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSearchListCurrent } from "../../Services/ApiCalling/Search";

// Async thunk for fetching listings
export const fetchConGenListings = createAsyncThunk(
  "searchListings/fetchConGenListings",
  async ({ token, user }) => {
    try {
      let data = await getSearchListCurrent(token, user);
      return { user: data };
    } catch (err) {}
  }
);

const searchListSlice = createSlice({
  name: "searchListings",
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConGenListings.pending, (state) => {})
      .addCase(fetchConGenListings.fulfilled, (state, action) => {
        state.fetchConGenListings = action.payload?.user?.data?.data;
      })
      .addCase(fetchConGenListings.rejected, (state, action) => {});
  },
});

export default searchListSlice.reducer;
